import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Button, message, Tabs } from 'antd';
import { useNavigate } from 'react-router-dom';

export default function Auth({ onLogin, onRegister }) {
  const [loading, setLoading] = useState(false);
  const [loginForm] = Form.useForm();
  const [registerForm] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const saved = localStorage.getItem('savedCredentials');
      if (saved) {
        const cred = JSON.parse(saved);
        if (cred && cred.username) {
          loginForm.setFieldsValue({ username: cred.username, password: cred.password || '' });
          registerForm.setFieldsValue({ username: cred.username });
        }
      }
    } catch (e) {
      // ignore
    }
  }, [loginForm, registerForm]);

  async function handleLogin(values) {
    setLoading(true);
    try {
      if (onLogin) {
        const res = await onLogin(values);
        if (res && res.success) {
          message.success('登录成功，欢迎回来');
          setLoading(false);
          // 使用 react-router 导航（避免页面 reload 导致状态未持久化）
          navigate('/');
          return;
        }
        if (res && res.fieldErrors) {
          // 将字段错误设置到表单（登录表单）
          const errFields = Object.keys(res.fieldErrors).map((k) => ({ name: k, errors: [res.fieldErrors[k]] }));
          loginForm.setFields(errFields);
        } else if (res && res.message) {
          message.error(res.message);
        }
      }
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  }

  async function handleRegister(values) {
    setLoading(true);
    try {
      if (values.password !== values.confirm) {
        registerForm.setFields([{ name: 'confirm', errors: ['两次输入的密码不一致'] }]);
        setLoading(false);
        return;
      }
      if (onRegister) {
        const res = await onRegister(values);
        if (res && res.success) {
          message.success('注册成功，已登录');
          setLoading(false);
          navigate('/');
          return;
        }
        if (res && res.fieldErrors) {
          const errFields = Object.keys(res.fieldErrors).map((k) => ({ name: k, errors: [res.fieldErrors[k]] }));
          registerForm.setFields(errFields);
        } else if (res && res.message) {
          message.error(res.message);
        }
      }
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  }

  return (
    <div className="page-container" style={{ maxWidth: 520 }}>
      <Card>
        <Tabs
          defaultActiveKey="login"
          items={[
            {
              key: 'login',
              label: '登录',
              children: (
                <Form form={loginForm} layout="vertical" onFinish={handleLogin}>
                  <Form.Item name="username" label="用户名" rules={[{ required: true, message: '请输入用户名' }]}>
                    <Input placeholder="用户名" />
                  </Form.Item>
                  <Form.Item name="password" label="密码" rules={[{ required: true, message: '请输入密码' }]}>
                    <Input.Password placeholder="密码" />
                  </Form.Item>
                  <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading}>登录</Button>
                  </Form.Item>
                </Form>
              ),
            },
            {
              key: 'register',
              label: '注册',
              children: (
                <Form form={registerForm} layout="vertical" onFinish={handleRegister}>
                  <Form.Item name="username" label="用户名" rules={[{ required: true, message: '请输入用户名' }]}>
                    <Input placeholder="用户名（将作为登录名）" />
                  </Form.Item>
                  <Form.Item name="password" label="密码" rules={[{ required: true, message: '请输入密码' }]}>
                    <Input.Password placeholder="密码" />
                  </Form.Item>
                  <Form.Item name="confirm" label="确认密码" rules={[{ required: true, message: '请再次输入密码' }]}>
                    <Input.Password placeholder="确认密码" />
                  </Form.Item>
                  <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading}>注册并登录</Button>
                  </Form.Item>
                </Form>
              ),
            },
          ]}
        />
      </Card>
    </div>
  );
}
